module.exports = __webpack_public_path__ + "static/three-55d7f05706a76d07b508c2dd1c8cee93.mp4";